<template>
    <div class="main_video_block">
        <div class="row">

            <div class="col-8">
                <div
                >

                    <div class="video-item">
                        <div class="video">
                            <a :href="curVideoItem['url']" rel="nofollow" class="video__link">
<!--                                {!! $main_video_link['image'] !!}-->
                                <div class="" v-html="curVideoItem['image']"></div>
                                <button class="video__button" aria-label="Запустить видео">
                                    <svg width="68" height="48" viewBox="0 0 68 48">
                                        <path class="video-button-shape"
                                              d="M66.52,7.74c-0.78-2.93-2.49-5.41-5.42-6.19C55.79,.13,34,0,34,0S12.21,.13,6.9,1.55 C3.97,2.33,2.27,4.81,1.48,7.74C0.06,13.05,0,24,0,24s0.06,10.95,1.48,16.26c0.78,2.93,2.49,5.41,5.42,6.19 C12.21,47.87,34,48,34,48s21.79-0.13,27.1-1.55c2.93-0.78,4.64-3.26,5.42-6.19C67.94,34.95,68,24,68,24S67.94,13.05,66.52,7.74z"></path>
                                        <path class="video-button-icon" d="M 45,24 27,14 27,34"></path>
                                    </svg>
                                </button>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-4 position-relative">
                <div class="video-preview-items-scroll-panel">


                    <div v-for="(videoItem, key) in allVideos"  class="video-item video-single"
                        >
                        <div class="video" :click="changeVideo(videoItem['url'])">
                            <a :href="videoItem['url']" rel="nofollow" class="video__link">
                                <div class="" v-html="videoItem['image']"></div>
                                <button class="video__button" aria-label="Запустить видео">
                                    <svg width="68" height="48" viewBox="0 0 68 48">
                                        <path class="video-button-shape"
                                              d="M66.52,7.74c-0.78-2.93-2.49-5.41-5.42-6.19C55.79,.13,34,0,34,0S12.21,.13,6.9,1.55 C3.97,2.33,2.27,4.81,1.48,7.74C0.06,13.05,0,24,0,24s0.06,10.95,1.48,16.26c0.78,2.93,2.49,5.41,5.42,6.19 C12.21,47.87,34,48,34,48s21.79-0.13,27.1-1.55c2.93-0.78,4.64-3.26,5.42-6.19C67.94,34.95,68,24,68,24S67.94,13.05,66.52,7.74z"></path>
                                        <path class="video-button-icon" d="M 45,24 27,14 27,34"></path>
                                    </svg>
                                </button>
                            </a>
                        </div>
                    </div>


<!--                    <div class="video-item video-single">-->
<!--                        <div class="video">-->
<!--                            <a href="{{url($main_page_video[0]['url'])}}" rel="nofollow" class="video__link">-->
<!--                                {!! $main_page_video[0]['image'] !!}-->
<!--                                <button class="video__button" aria-label="Запустить видео">-->
<!--                                    <svg width="68" height="48" viewBox="0 0 68 48">-->
<!--                                        <path class="video-button-shape"-->
<!--                                              d="M66.52,7.74c-0.78-2.93-2.49-5.41-5.42-6.19C55.79,.13,34,0,34,0S12.21,.13,6.9,1.55 C3.97,2.33,2.27,4.81,1.48,7.74C0.06,13.05,0,24,0,24s0.06,10.95,1.48,16.26c0.78,2.93,2.49,5.41,5.42,6.19 C12.21,47.87,34,48,34,48s21.79-0.13,27.1-1.55c2.93-0.78,4.64-3.26,5.42-6.19C67.94,34.95,68,24,68,24S67.94,13.05,66.52,7.74z"></path>-->
<!--                                        <path class="video-button-icon" d="M 45,24 27,14 27,34"></path>-->
<!--                                    </svg>-->
<!--                                </button>-->
<!--                            </a>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div class="video-item">-->
<!--                        <div class="video">-->
<!--                            <a href="{{url($main_page_video[1]['url'])}}" rel="nofollow" class="video__link">-->
<!--                                {!! $main_page_video[1]['image'] !!}-->
<!--                                <button class="video__button" aria-label="Запустить видео">-->
<!--                                    <svg width="68" height="48" viewBox="0 0 68 48">-->
<!--                                        <path class="video-button-shape"-->
<!--                                              d="M66.52,7.74c-0.78-2.93-2.49-5.41-5.42-6.19C55.79,.13,34,0,34,0S12.21,.13,6.9,1.55 C3.97,2.33,2.27,4.81,1.48,7.74C0.06,13.05,0,24,0,24s0.06,10.95,1.48,16.26c0.78,2.93,2.49,5.41,5.42,6.19 C12.21,47.87,34,48,34,48s21.79-0.13,27.1-1.55c2.93-0.78,4.64-3.26,5.42-6.19C67.94,34.95,68,24,68,24S67.94,13.05,66.52,7.74z"></path>-->
<!--                                        <path class="video-button-icon" d="M 45,24 27,14 27,34"></path>-->
<!--                                    </svg>-->
<!--                                </button>-->
<!--                            </a>-->
<!--                        </div>-->
<!--                    </div>-->
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    // import Vue2TouchEvents from 'vue2-touch-events';
    //
    // Vue.use(Vue2TouchEvents);

    // available transition type fade, scroll
    export default {
        name: 'main-video-block',
        props: {
            allVideos: {
                required: false,
            },
        },
        data() {
            return {
                curVideoItem:'',
                currentUrl: '',
                curIndexVideo: 0,
            }
        },
        computed: {

            // skipSlides() {
            //     let skip = this.currentSlidesIndex;
            //     if (this.options.slidesToScroll !== 1) {
            //         skip = this.currentSlidesIndex * this.options.slidesToScroll;
            //     }
            //     return skip;
            // }
        },
        watch: {

            // currentSlidesIndex: function (newVal, oldVal) {
            //     if (newVal > oldVal) {
            //         this.scrollTo = 'left-scroll';
            //     }
            //     else {
            //         this.scrollTo = 'right-scroll';
            //     }
            // }
        },
        methods: {
            // changeImageByDot(id) {
            //     let imgIndex = this.slides.findIndex((element, index, array) => {
            //         if (element.id === id) {
            //             return element;
            //         }
            //     });
            //
            //     this.currentSlidesIndex = imgIndex;
            // },
            changeVideo(videoItem) {
                console.log("123");
                this.curVideoItem = videoItem;
            },
        },
        updated: function () {
            // this.resetTimeToNextSlide();
        },
        mounted() {
            //check on mobile devices
            // if (document.documentElement.clientWidth <= 768) {
            //     this.mobile = true;
            // }

        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/elements/MainVideoBlock.vue